import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import FormatCrypto from "@hl/base-components/lib/FormatCrypto";
import { Text } from "@mantine/core";
const MarketplacePrice = ({ price, ...rest }) => {
    var _a, _b;
    return (_jsx(Text, { ...rest, children: _jsx(FormatCrypto, { onlyText: true, amount: (_a = price === null || price === void 0 ? void 0 : price.amount) === null || _a === void 0 ? void 0 : _a.raw, symbol: (_b = price === null || price === void 0 ? void 0 : price.currency) === null || _b === void 0 ? void 0 : _b.symbol }) }));
};
export default MarketplacePrice;
